/* Rakspiri – Jóladagatal 3D (interactive advent calendar viewer)
   Built for section "advent-calendar-3d". Needs THREE r128 + OrbitControls. */
(function () {
  'use strict';

  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var ORBIT_URL = 'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/OrbitControls.js';

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var existing = document.querySelector('script[data-ac3d-src="' + src + '"]');
      if (existing) { existing.addEventListener('load', res); if (existing.dataset.loaded) res(); return; }
      var s = document.createElement('script');
      s.src = src; s.async = true; s.dataset.ac3dSrc = src;
      s.onload = function () { s.dataset.loaded = '1'; res(); };
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function ensureThree() {
    var p = window.THREE ? Promise.resolve() : loadScript(THREE_URL);
    return p.then(function () { return THREE.OrbitControls ? null : loadScript(ORBIT_URL); });
  }

  function init(el) {
    if (el.dataset.ac3dReady) return;
    el.dataset.ac3dReady = '1';
    var cfg = JSON.parse(el.getAttribute('data-config') || '{}');
    ensureThree().then(function () { build(el, cfg); }).catch(function () {
      el.classList.add('ac3d--failed');
    });
  }

  function build(el, cfg) {
    var W = 212, H = 212, D = 28, GLUE = 22, PPM = 7, HP = Math.PI / 2, G = 92 * Math.PI / 180;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var st = {
      frontColor: cfg.frontColor || '#000000', numColor: cfg.numColor || '#d9b871',
      numFont: 'Emilys Candy', backColor: cfg.backColor || '#000000', textColor: cfg.textColor || '#d9b871',
      snowColor: '#f1e8d2', snow: 60, sub: cfg.subtitle || 'Jóladagatal 2026',
      order: [11, 18, 12, 3, 6, 2, 23, 4, 13, 9, 17, 8, 10, 14, 15, 16, 22, 19, 5, 1, 7, 20, 21, 24]
    };

    var stage = el.querySelector('.ac3d__stage'), canvas = el.querySelector('canvas');
    var slots = [];
    for (var r = 0; r < 5; r++) for (var c = 0; c < 5; c++) {
      if (r === 4 && c >= 3) continue;
      slots.push({ x0: 11 + 40 * c, y0: 171 - 40 * r, w: 30, h: 30, wide: false });
    }
    slots.push({ x0: 131, y0: 11, w: 70, h: 30, wide: true });

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(32, 1, 1, 6000);
    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enableDamping = true; controls.dampingFactor = .08;
    controls.enableZoom = false; controls.enablePan = false;
    controls.autoRotate = !reduce; controls.autoRotateSpeed = 1.2;
    scene.add(new THREE.HemisphereLight(0xffffff, 0x80857c, .85));
    var key = new THREE.DirectionalLight(0xffffff, .85); key.position.set(300, 420, 520); scene.add(key);
    var fill = new THREE.DirectionalLight(0xffffff, .35); fill.position.set(-350, -200, -300); scene.add(fill);
    var fill2 = new THREE.DirectionalLight(0xffffff, .25); fill2.position.set(-300, 100, 400); scene.add(fill2);

    function srgb(h) { return new THREE.Color().setStyle(h).convertSRGBToLinear(); }
    function mkTex(w, h) {
      var cv = document.createElement('canvas'); cv.width = Math.round(w * PPM); cv.height = Math.round(h * PPM);
      var tex = new THREE.CanvasTexture(cv); tex.encoding = THREE.sRGBEncoding;
      tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
      return { cv: cv, ctx: cv.getContext('2d'), tex: tex, w: w, h: h };
    }
    var T = { front: mkTex(W, H), back: mkTex(W, H), left: mkTex(D, H), right: mkTex(D, H), top: mkTex(W, D), bottom: mkTex(W, D) };
    function mat(k) { return new THREE.MeshStandardMaterial({ map: T[k].tex, roughness: .55, metalness: 0 }); }
    var M = {
      front: mat('front'), back: mat('back'), left: mat('left'), right: mat('right'), top: mat('top'), bottom: mat('bottom'),
      plain: new THREE.MeshStandardMaterial({ roughness: .6, color: srgb(st.backColor) }),
      inside: new THREE.MeshStandardMaterial({ color: srgb('#ede7da'), roughness: .9, side: THREE.BackSide })
    };
    var edgeMat = new THREE.LineBasicMaterial({ color: 0x000000, transparent: true, opacity: .28 });

    function rectShape(x0, y0, w, h) { var s = new THREE.Shape(); s.moveTo(x0, y0); s.lineTo(x0 + w, y0); s.lineTo(x0 + w, y0 + h); s.lineTo(x0, y0 + h); s.lineTo(x0, y0); return s; }
    function polyShape(pts) { var s = new THREE.Shape(); pts.forEach(function (p, i) { i ? s.lineTo(p[0], p[1]) : s.moveTo(p[0], p[1]); }); s.lineTo(pts[0][0], pts[0][1]); return s; }
    function doorShape(s) {
      var sh = new THREE.Shape(), x0 = s.x0, y0 = s.y0, x1 = x0 + s.w, y1 = y0 + s.h;
      if (!s.wide) { var cx = x0 + s.w / 2; sh.moveTo(x0, y0); sh.lineTo(cx - 7, y0); sh.absellipse(cx, y0, 7, 4.5, Math.PI, 0, true); sh.lineTo(x1, y0); sh.lineTo(x1, y1); sh.lineTo(x0, y1); sh.lineTo(x0, y0); }
      else { var cy = y0 + s.h / 2; sh.moveTo(x0, y0); sh.lineTo(x1, y0); sh.lineTo(x1, cy - 7); sh.absellipse(x1, cy, 4.5, 7, -Math.PI / 2, Math.PI / 2, true); sh.lineTo(x1, y1); sh.lineTo(x0, y1); sh.lineTo(x0, y0); }
      return sh;
    }
    function shapeMesh(shape, x0, y0, w, h, outer, ox, oy) {
      var g = new THREE.ShapeGeometry(shape, 32), p = g.attributes.position, uv = g.attributes.uv;
      for (var i = 0; i < p.count; i++) uv.setXY(i, (p.getX(i) - x0) / w, (p.getY(i) - y0) / h);
      uv.needsUpdate = true; if (ox || oy) g.translate(-(ox || 0), -(oy || 0), 0);
      var grp = new THREE.Group(), a = new THREE.Mesh(g, outer), b = new THREE.Mesh(g, M.inside);
      grp.add(a, b, new THREE.LineSegments(new THREE.EdgesGeometry(g), edgeMat));
      return { grp: grp, meshes: [a, b] };
    }
    function pivot(parent, x, y, z) { var g = new THREE.Group(); g.position.set(x, y, z || 0); parent.add(g); return g; }

    var root = new THREE.Group(); root.position.set(-W / 2, -H / 2, D / 2); scene.add(root);
    var frontShape = rectShape(0, 0, W, H);
    slots.forEach(function (s) { var p = new THREE.Path(); p.moveTo(s.x0, s.y0); p.lineTo(s.x0, s.y0 + s.h); p.lineTo(s.x0 + s.w, s.y0 + s.h); p.lineTo(s.x0 + s.w, s.y0); p.lineTo(s.x0, s.y0); frontShape.holes.push(p); });
    root.add(shapeMesh(frontShape, 0, 0, W, H, M.front).grp);

    var clickables = [];
    var doors = slots.map(function (s, k) {
      var hx = s.x0, hy = s.wide ? s.y0 : s.y0 + s.h, pv = pivot(root, hx, hy, .2);
      var m = shapeMesh(doorShape(s), 0, 0, W, H, M.front, hx, hy); pv.add(m.grp);
      m.meshes.forEach(function (o) { o.userData.slot = k; clickables.push(o); });
      return { pv: pv, s: s, cur: 0, target: 0 };
    });

    var dust = [[1, 0], [1, 18], [5, 23], [22, 23], [27, 15], [27, 0]];
    function dustS(sx, sy) { return polyShape(dust.map(function (p) { return [p[0] * sx, p[1] * sy]; })); }
    var rw = pivot(root, W, 0); rw.add(shapeMesh(rectShape(0, 0, D, H), 0, 0, D, H, M.right).grp);
    var rwT = pivot(rw, 0, H); rwT.add(shapeMesh(dustS(1, 1), 0, 0, 1, 1, M.plain).grp);
    var rwB = pivot(rw, 0, 0); rwB.add(shapeMesh(dustS(1, -1), 0, 0, 1, 1, M.plain).grp);
    var lw = pivot(root, 0, 0); lw.add(shapeMesh(rectShape(-D, 0, D, H), -D, 0, D, H, M.left).grp);
    var lwT = pivot(lw, 0, H); lwT.add(shapeMesh(dustS(-1, 1), 0, 0, 1, 1, M.plain).grp);
    var lwB = pivot(lw, 0, 0); lwB.add(shapeMesh(dustS(-1, -1), 0, 0, 1, 1, M.plain).grp);
    var bp = pivot(lw, -D, 0); bp.add(shapeMesh(rectShape(-W, 0, W, H), -W, 0, W, H, M.back).grp);
    var gp = pivot(bp, -W, 0); gp.add(shapeMesh(polyShape([[0, 0], [-GLUE, 5], [-GLUE, H - 5], [0, H]]), 0, 0, 1, 1, M.plain).grp);
    function tuck(sy) { return polyShape([[1, 0], [211, 0], [211, 13 * sy], [208, 18 * sy], [203, 20 * sy], [9, 20 * sy], [4, 18 * sy], [1, 13 * sy]]); }
    var tw = pivot(root, 0, H); tw.add(shapeMesh(rectShape(0, 0, W, D), 0, 0, W, D, M.top).grp);
    var tt = pivot(tw, 0, D); tt.add(shapeMesh(tuck(1), 0, 0, 1, 1, M.plain).grp);
    var bw = pivot(root, 0, 0); bw.add(shapeMesh(rectShape(0, -D, W, D), 0, -D, W, D, M.bottom).grp);
    var tb = pivot(bw, 0, -D); tb.add(shapeMesh(tuck(-1), 0, 0, 1, 1, M.plain).grp);

    // fold to closed box
    (function () {
      rw.rotation.y = HP; lw.rotation.y = -HP; bp.rotation.y = -HP; gp.rotation.y = -G;
      rwT.rotation.x = lwT.rotation.x = -G; rwB.rotation.x = lwB.rotation.x = G;
      tw.rotation.x = -HP; bw.rotation.x = HP; tt.rotation.x = -G; tb.rotation.x = G;
    })();

    // decants
    var glassM = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .05, metalness: .1, transparent: true, opacity: .32 });
    var capM = new THREE.MeshStandardMaterial({ color: srgb('#b9944f'), roughness: .3, metalness: .55 });
    var juices = ['#d49a3a', '#e8c98a', '#c46a4a', '#b9c98a', '#e3b3a0', '#a8763a'].map(function (h) { return new THREE.MeshStandardMaterial({ color: srgb(h), roughness: .3 }); });
    slots.forEach(function (s, k) {
      var g = new THREE.Group(), cx = s.x0 + s.w / 2, cy = s.y0 + s.h / 2, j = juices[k % juices.length];
      if (!s.wide) {
        var glass = new THREE.Mesh(new THREE.CylinderGeometry(4.2, 4.2, 20, 24), glassM);
        var liq = new THREE.Mesh(new THREE.CylinderGeometry(3.6, 3.6, 14, 24), j); liq.position.y = -2.5;
        var cap = new THREE.Mesh(new THREE.CylinderGeometry(4.4, 4.4, 6, 24), capM); cap.position.y = 13;
        g.add(glass, liq, cap); g.rotation.z = -HP; g.position.set(cx - 3, cy + 1, -12);
      } else {
        var glass2 = new THREE.Mesh(new THREE.BoxGeometry(36, 18, 10), glassM);
        var liq2 = new THREE.Mesh(new THREE.BoxGeometry(33, 13, 8.4), j); liq2.position.y = -1.8;
        var neck = new THREE.Mesh(new THREE.CylinderGeometry(4.6, 4.6, 9, 24), capM); neck.rotation.z = HP; neck.position.x = 22.5;
        g.add(glass2, liq2, neck); g.position.set(cx - 8, cy, -12);
      }
      root.add(g);
    });

    // textures
    function helpers(t) { return { ctx: t.ctx, X: function (mm) { return mm * PPM; }, Y: function (mm) { return (t.h - mm) * PPM; }, S: function (mm) { return mm * PPM; } }; }
    function bg(t, color) { var c = t.ctx; c.save(); c.fillStyle = color; c.fillRect(0, 0, t.cv.width, t.cv.height); c.restore(); }
    function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
    function drawFront() {
      var t = T.front, h = helpers(t), ctx = h.ctx, X = h.X, Y = h.Y, S = h.S; bg(t, st.frontColor);
      var rr = rng(731), amt = st.snow / 100; ctx.save(); ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.fillStyle = ctx.strokeStyle = st.snowColor;
      var keep = slots.map(function (s) { return { x: s.wide ? s.x0 + s.w / 2 - 3 : s.x0 + s.w / 2, y: s.wide ? s.y0 + s.h / 2 : s.y0 + s.h * .58, rx: s.wide ? 10 : 7, ry: 7 }; });
      function nearNum(x, y, p) { return keep.some(function (k) { return Math.abs(x - k.x) < k.rx + p && Math.abs(y - k.y) < k.ry + p; }); }
      var nd = Math.round(320 * amt), i;
      for (i = 0; i < nd; i++) { var x = rr() * W, y = rr() * H, rad = .22 + rr() * .55; ctx.globalAlpha = .22 + rr() * .45; ctx.beginPath(); ctx.arc(X(x), Y(y), S(rad), 0, Math.PI * 2); ctx.fill(); }
      var placed = [], nf = Math.round(52 * amt), tries = 0;
      while (placed.length < nf && tries < 3000) {
        tries++; var big = rr() < .22, R = big ? 5.5 + rr() * 4.5 : 1.8 + rr() * 2.8, fx = rr() * W, fy = rr() * H, rot = rr() * Math.PI;
        if (nearNum(fx, fy, R * .5) || placed.some(function (p) { return Math.hypot(p.x - fx, p.y - fy) < p.R + R + 2.5; })) continue;
        placed.push({ x: fx, y: fy, R: R });
        ctx.globalAlpha = big ? .5 : .8; ctx.lineWidth = S(Math.max(.22, R * .07));
        for (var k = 0; k < 6; k++) {
          var a = rot + k * Math.PI / 3, ux = Math.cos(a), uy = Math.sin(a);
          ctx.beginPath(); ctx.moveTo(X(fx + ux * R * .16), Y(fy + uy * R * .16)); ctx.lineTo(X(fx + ux * R), Y(fy + uy * R));
          [[.42, .34], [.7, .22]].forEach(function (q) { var bx = fx + ux * R * q[0], by = fy + uy * R * q[0]; [.8, -.8].forEach(function (d) { var ba = a + d; ctx.moveTo(X(bx), Y(by)); ctx.lineTo(X(bx + Math.cos(ba) * R * q[1]), Y(by + Math.sin(ba) * R * q[1])); }); });
          ctx.stroke(); ctx.beginPath(); ctx.arc(X(fx + ux * R), Y(fy + uy * R), S(Math.max(.2, R * .055)), 0, Math.PI * 2); ctx.fill();
        }
        ctx.beginPath(); for (k = 0; k < 6; k++) { var a2 = rot + k * Math.PI / 3 + Math.PI / 6, px = X(fx + Math.cos(a2) * R * .16), py = Y(fy + Math.sin(a2) * R * .16); k ? ctx.lineTo(px, py) : ctx.moveTo(px, py); } ctx.closePath(); ctx.stroke();
      }
      ctx.restore();
      slots.forEach(function (s, k) {
        ctx.save(); ctx.strokeStyle = st.numColor; ctx.globalAlpha = .6; ctx.lineWidth = S(.35); ctx.strokeRect(X(s.x0 + 2), Y(s.y0 + s.h - 2), S(s.w - 4), S(s.h - 4)); ctx.restore();
        ctx.fillStyle = st.numColor; ctx.font = '400 ' + S(s.wide ? 17 : 13) + 'px "' + st.numFont + '", Georgia, serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(String(st.order[k]), X(s.wide ? s.x0 + s.w / 2 - 3 : s.x0 + s.w / 2), Y(s.wide ? s.y0 + s.h / 2 : s.y0 + s.h * .58));
      });
      t.tex.needsUpdate = true;
    }
    var logoImg = null;
    function drawBack() {
      var t = T.back, h = helpers(t), ctx = h.ctx, X = h.X, Y = h.Y, S = h.S; bg(t, st.backColor);
      var subY = 106;
      if (logoImg) {
        var lw0 = logoImg.naturalWidth || 2749, lh0 = logoImg.naturalHeight || 408;
        var s = Math.min(S(120) / lw0, S(36) / lh0), dw = lw0 * s, dh = lh0 * s;
        ctx.drawImage(logoImg, X(W / 2) - dw / 2, Y(122) - dh / 2, dw, dh);
        subY = Math.max(10, 122 - dh / PPM / 2 - 10);
      }
      ctx.fillStyle = st.textColor; ctx.textBaseline = 'middle'; ctx.textAlign = 'center';
      ctx.font = 'italic 400 ' + S(8) + 'px "Playfair Display", Georgia, serif'; ctx.fillText(st.sub, X(W / 2), Y(subY));
      t.tex.needsUpdate = true;
    }
    function drawWall(t, text) {
      var h = helpers(t), ctx = h.ctx, S = h.S; bg(t, st.backColor);
      if (text) { ctx.save(); ctx.fillStyle = st.textColor; ctx.textBaseline = 'middle'; ctx.textAlign = 'center'; ctx.font = '400 ' + S(9) + 'px Italiana, Georgia, serif'; ctx.fillText(text, t.cv.width / 2, t.cv.height / 2); ctx.restore(); }
      t.tex.needsUpdate = true;
    }
    function redraw() { drawFront(); drawBack(); drawWall(T.left); drawWall(T.right); drawWall(T.top); drawWall(T.bottom, st.sub); }
    redraw();
    if (cfg.logo) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { logoImg = im; drawBack(); }; im.src = cfg.logo; }
    if (document.fonts && document.fonts.load) {
      Promise.all(['400 40px "Emilys Candy"', 'italic 400 40px "Playfair Display"', '400 40px Italiana'].map(function (f) { return document.fonts.load(f); }))
        .then(redraw).catch(function () {});
    }

    // camera / size
    function fitDist(size) { var v = camera.fov * Math.PI / 180, hh = 2 * Math.atan(Math.tan(v / 2) * camera.aspect); return size / 2 / Math.tan(Math.min(v, hh) / 2) * 1.12; }
    function resetView() { controls.target.set(0, 0, 0); camera.position.set(.35, .2, 1).normalize().multiplyScalar(fitDist(285)); controls.update(); }
    function resize() { var rc = stage.getBoundingClientRect(); if (!rc.width || !rc.height) return; renderer.setSize(rc.width, rc.height, false); camera.aspect = rc.width / rc.height; camera.updateProjectionMatrix(); }
    if (window.ResizeObserver) new ResizeObserver(function () { resize(); }).observe(stage); else window.addEventListener('resize', resize);
    resize(); resetView();

    // tapping doors
    var ray = new THREE.Raycaster(), ndc = new THREE.Vector2(), down = null, idleTimer = null;
    function stopSpin() { controls.autoRotate = false; clearTimeout(idleTimer); if (!reduce) idleTimer = setTimeout(function () { controls.autoRotate = true; }, 8000); }
    canvas.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, t: performance.now() }; stopSpin(); });
    canvas.addEventListener('pointerup', function (e) {
      if (!down) return; var moved = Math.hypot(e.clientX - down.x, e.clientY - down.y), dt = performance.now() - down.t; down = null;
      if (moved > 6 || dt > 500) return; var rc = canvas.getBoundingClientRect();
      ndc.set((e.clientX - rc.left) / rc.width * 2 - 1, -((e.clientY - rc.top) / rc.height) * 2 + 1);
      ray.setFromCamera(ndc, camera); var hit = ray.intersectObjects(clickables, false)[0];
      if (hit) { var d = doors[hit.object.userData.slot]; d.target = d.target ? 0 : 1; }
    });
    var btnOpen = el.querySelector('[data-ac3d-open]'), btnClose = el.querySelector('[data-ac3d-close]'), btnReset = el.querySelector('[data-ac3d-reset]');
    if (btnOpen) btnOpen.addEventListener('click', function () { stopSpin(); doors.forEach(function (d) { d.target = 1; }); });
    if (btnClose) btnClose.addEventListener('click', function () { doors.forEach(function (d) { d.target = 0; }); });
    if (btnReset) btnReset.addEventListener('click', function () { stopSpin(); resetView(); });

    // invite: door 1 starts open
    var first = doors[st.order.indexOf(1)]; if (first) { first.target = 1; first.cur = 1; }

    // render only while on screen
    var visible = true;
    if (window.IntersectionObserver) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(stage);
    function tick() {
      requestAnimationFrame(tick);
      if (!visible) return;
      doors.forEach(function (d) {
        if (d.cur !== d.target) { d.cur += reduce ? d.target - d.cur : (d.target - d.cur) * .14; if (Math.abs(d.target - d.cur) < .002) d.cur = d.target; }
        var a = -d.cur * 105 * Math.PI / 180; if (d.s.wide) d.pv.rotation.y = a; else d.pv.rotation.x = a;
      });
      controls.update(); renderer.render(scene, camera);
    }
    tick();
    el.classList.add('ac3d--ready');
  }

  function boot() {
    var els = document.querySelectorAll('div[data-ac3d]');
    els.forEach(function (el) {
      if (!window.IntersectionObserver) { init(el); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); init(el); } }, { rootMargin: '300px' });
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
